// @ts-ignore
import { hsluv } from "d3-hsluv";

export default function orderColorsByLuminosity<Color extends string>(
  colors: Color[],
  direction: "toLight" | "toDark" = "toLight",
) {
  const luminosities: Array<{
    color: string;
    luminosity: number;
  }> = colors.map((color) => {
    return {
      color,
      luminosity: hsluv(color).v,
    };
  });
  if (direction === "toLight") {
    luminosities.sort((a, b) => {
      return a.luminosity < b.luminosity ? 1 : -1;
    });
    return luminosities.map((c) => c.color);
  }
  luminosities.sort((a, b) => {
    return a.luminosity < b.luminosity ? -1 : 1;
  });
  return luminosities.map((c) => c.color);
}
